import React from 'react';
import { Select, MenuItem } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { createTheme } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';
import ColorConstants from '../../../defaults/ColorConstants';

const theme = createTheme({
  overrides: {
  },
});

const useStyles = makeStyles({
  root: {
    "&:hover": {
      borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`,
    }
  },
});

export default function UniqueValueChooser() {
  const classes = useStyles();
  return (
    <ThemeProvider theme={theme}>
    <Select
      style={{ whiteSpace: 'nowrap', width: '100%', padding: '0 5px' }}
      MenuProps={{
            sx: {
              "&& .Mui-selected": {
                borderLeft: `4px solid ${ColorConstants.BlueAlien} !important`
              },
            }
          }}
    >
      <MenuItem classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}}>Coming Soon!</MenuItem>
      <MenuItem classes={{root: classes.root, selected: classes.selected}} style={{ display: 'block', padding: 5, borderLeft: `4px solid ${ColorConstants.WhiteAlien}`}} />
    </Select>
    </ThemeProvider>
  );
}
